import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=08aaa979"
import script from "./AdminManagement.vue?vue&type=script&lang=ts"
export * from "./AdminManagement.vue?vue&type=script&lang=ts"
import style0 from "./AdminManagement.vue?vue&type=style&index=0&id=08aaa979&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports